import React from 'react';
import { Loader2 } from 'lucide-react';

export function PageLoader() {
  return (
    <div className="flex items-center justify-center py-20 text-slate-500">
      <Loader2 size={18} className="animate-spin mr-2" /> Loading…
    </div>
  );
}

export function InlineLoader({ label = 'Loading…' }) {
  return (
    <div className="flex items-center text-slate-500 text-sm gap-2">
      <Loader2 size={14} className="animate-spin" /> {label}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="py-12 text-center">
      {Icon && (
        <div className="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3 text-slate-400">
          <Icon size={20} />
        </div>
      )}
      <div className="text-sm font-medium text-slate-700">{title}</div>
      {description && <div className="text-xs text-slate-500 mt-1 max-w-sm mx-auto">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
